import { render, staticRenderFns } from "./bandejaFilters.vue?vue&type=template&id=76cf31b2"
import script from "./bandejaFilters.vue?vue&type=script&lang=js"
export * from "./bandejaFilters.vue?vue&type=script&lang=js"
import style0 from "./bandejaFilters.vue?vue&type=style&index=0&id=76cf31b2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports